import { LocaleStartParams } from '@platform-frontend/transloco';
import { ShowErrorNotification, ShowInfoNotification, ShowSuccessNotification, ShowWarningNotification } from '@platform-frontend/util';
import { AccountGotoAction } from '../account-router';
import { Credentials } from './model/credentials';
import { GotoSignInNavigationExtras } from './model/goto-sign-in-navigation-extras';
import { Session } from './model/session';
import { SignOutFollowUp } from './model/sign-out-follow-up';

export class SignIn {
  static readonly type = '[Session] Sign in';
  constructor(public credentials: Credentials) {}
}

export class SetSession {
  static readonly type = '[Session] Set session';
  constructor(public session: Session | null) {}
}

export class SessionSet {
  static readonly type = '[Session] Session set';
  constructor(public isSignedIn: boolean, public isDisabled: boolean | null) {}
}

export class UpdateSessionFromBrowser {
  static readonly type = '[Session] Update session from browser';
}

export class SignOut {
  static readonly type = '[Session] Sign out';
  constructor(public followUp: SignOutFollowUp = 'closeOrAuthenticate') {}
}

export class SignOutOnError {
  static readonly type = '[Session] Sign out on error';
  constructor(
    public notificationAction?: ShowSuccessNotification | ShowInfoNotification | ShowWarningNotification | ShowErrorNotification,
    public resetToLinkedAccount: boolean = false
  ) {}
}

export class GotoSignIn<T extends LocaleStartParams = LocaleStartParams> extends AccountGotoAction {
  static readonly type = '[Session] Goto sign in';
  constructor(public extras?: GotoSignInNavigationExtras<T>) {
    super(extras);
  }
}

export class GotoCheckRecoveryEmail extends AccountGotoAction {
  static readonly type = '[Session] Goto check recovery email';
}

export class CompareSessionWithLinkedAccount {
  static readonly type = '[Session] Compare session with linked account';
}
